import React from 'react';
import {Chip} from '@mui/material';
import {helper} from "../../../utils/helper.js";
import { useTheme } from '@mui/material/styles';

function TypologieLavageBadge({ typologie, small = false, selected = true, onClick = null }) {
    if (!typologie) return null;

    const theme = useTheme();
    const trueColor = typologie.couleur || "#ccc";
    const baseBackground = selected ? trueColor : "#f0f0f0";
    const baseTextColor = selected ? theme.palette.getContrastText(trueColor) : "#000";
    const hoverBackground = trueColor;
    const hoverTextColor = theme.palette.getContrastText(trueColor);

    return (
        <Chip
            label={typologie?.libelle?.toUpperCase()}
            onClick={onClick}
            sx={{
                backgroundColor: baseBackground,
                color: baseTextColor,
                fontWeight: 500,
                fontSize: small ? "0.75rem" : "0.875rem",
                height: small ? 24 : 32,
                border: '1px solid #ddd',
                cursor: onClick ? 'pointer' : 'default',
                padding: '.33rem',
                transition: 'background-color 0.3s ease, color 0.3s ease',
                '&:hover': onClick
                    ? {
                        backgroundColor: hoverBackground,
                        color: hoverTextColor,
                    }
                    : {},
            }}
        />
    );
}



export default TypologieLavageBadge;
